module.exports = __webpack_public_path__ + "img/returns.087294f2.svg";